var React = require('react');

function ArrowBackward (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-backward"),React.createElement("line",{"x1":"5.7","y1":"33.2","x2":"33.4","y2":"5.5","fill":"none","stroke":"#63b3ed","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"10","key":1}),React.createElement("line",{"x1":"5.7","y1":"33.2","x2":"33.4","y2":"60.9","fill":"#fff","stroke":"#63b3ed","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"10","key":2})]);
}

ArrowBackward.defaultProps = {"id":"arrow-back","data-name":"Layer 1","viewBox":"0 0 38.8 66.1"};

module.exports = ArrowBackward;

ArrowBackward.default = ArrowBackward;
